export default {
	InvalidMemberId:1,
	MismatchName:2,
	MismatchSchool:3,
	EligibilityFlag:4,
	InvalidEventRosterSize:5,
	InvalidSeasonRosterSize:6,
	InvalidAcademicEligibility:7,
	ExceededMaxSeasonsEligibility:8,
	GameTotMoreThan5xNoOfGames:9,
	GameTotLessThen5xNoOfGames:10,
	BakerGameTotLessThanRequired:11,
	TeamUsedIneligibleBowler:12
}


// WEBPACK FOOTER //
// ./src/utils/constants/exceptionType.js